import { render, staticRenderFns } from "./SsCard.vue?vue&type=template&id=3b8f97ab&scoped=true"
import script from "./SsCard.vue?vue&type=script&lang=js"
export * from "./SsCard.vue?vue&type=script&lang=js"
import style0 from "./SsCard.vue?vue&type=style&index=0&id=3b8f97ab&prod&lang=scss&scoped=true"
import style1 from "./SsCard.vue?vue&type=style&index=1&id=3b8f97ab&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b8f97ab",
  null
  
)

export default component.exports